import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  name: [
    {...makeRule()},
  ],
}

export let formRules = {
  company_name: [
    {...makeRule('账户名称不能为空', 'string', 'blur', true)},
  ],
  bank_account: [
    {required: true, message: '银行账号不能为空', trigger: 'blur'},
  ],
  bank: [
    {required: true, message: '开户银行支行不能为空', trigger: 'blur'},
  ],
  bank_headquarters: [
    {required: true, message: '开户银行总行不能为空', trigger: 'blur'},
  ],
}



// WEBPACK FOOTER //
// ./src/views/company-bank-account/company-bank-account.rules.js